// views
import { Row, Col } from "antd";
import Icon from "@ant-design/icons";
import UserTag from "~/components/user/UserTag";
import UserAvatar from "~/components/user/UserAvatar";
import UserLevel from "~/components/users/UserLevel";
import UserAvatarEditor from "~/components/user/UserAvatarEditor";
import UserBind from "~/components/user/UserBind";
import UserResume from "~/components/user/UserResume";
import settings from "~/settings";
import { hasAnyRole } from "../../utils/user";
import moment from "moment";
import EditIcon from "~/components/app/EditIcon";
import { useUserRoute } from "hooks/useUserRoute";

export default (props) => {
  const { user, withResume = false } = props;
  const isContributor = hasAnyRole(props.user, ["contributor"]);
  const isProhibitor = hasAnyRole(props.user, ["prohibitor"]);
  const { userProfileUrl } = useUserRoute(user);

  const renderTag = (tag) => (
    <UserTag
      key={tag.id}
      tag={tag}
    />
  );

  const handleLinkToUser = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div className={`user-info-block${props.small ? " small" : ""}`}>
      {user && (
        <Row
          type="flex"
          align="start"
        >
          <Col style={{ marginRight: "8px" }}>
            {props.profile ? (
              <UserAvatarEditor />
            ) : (
              <UserAvatar
                user={user}
                size={48}
              />
            )}
          </Col>
          <Col style={{ flex: 1 }}>
            <Row
              type="flex"
              justify="space-between"
              align="middle"
            >
              <Col
                className="body"
                onClick={handleLinkToUser.bind(null, userProfileUrl)}
                style={{ cursor: "pointer" }}
              >
                <div className="user-info-box">
                  <h3>
                    {user.nickname}
                    {isProhibitor ? " [已封禁]" : ""}
                  </h3>
                  {isContributor && (
                    <div
                      style={{
                        marginLeft: "6px",
                        color: "#2dbaab",
                        fontSize: "14px",
                      }}
                    >
                      社区共建者
                    </div>
                  )}
                  {props.showLevel && <UserLevel level={user.level_info} />}
                  {props.profile && <UserBind />}
                </div>

                {user.tagline && <p>{user.tagline}&nbsp;</p>}

                {!props.small && (
                  <div style={{ lineHeight: "14px" }}>
                    {user.tags && user.tags.map(renderTag)}
                    {withResume && <UserResume />}
                  </div>
                )}
                {props.showCreateTime && (
                  <div className="text-secondary font-12">
                    创建于{moment(user.created_at).format("YYYY年MM月DD日")}
                  </div>
                )}
              </Col>
              {props.extra}
            </Row>
          </Col>
          {props.withEditIcon && (
            <Col onClick={handleLinkToUser.bind(null, userProfileUrl)}>
              <Icon
                component={EditIcon}
                style={{ color: "#A8A8A8", cursor: "pointer" }}
              />
            </Col>
          )}
        </Row>
      )}
    </div>
  );
};
